  const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);

  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy";
  return newImage;
};

const _productCache = new Map();
const fetchProductByHandle = async (handleProduct) => {
  if (_productCache.has(handleProduct)) return _productCache.get(handleProduct);
  const rootUrl = window.Shopify?.routes?.root || "/";
  const response = await fetch(`${rootUrl}products/${handleProduct}.js`);
  if (!response.ok) {
    return null;
  }

  const product = await response.json();
  _productCache.set(handleProduct, product);
  return product;
};

const bindColorSwatches = (root = document) => {
  root.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      if (input.dataset.swatchBound === "true") {
        return;
      }

      input.dataset.swatchBound = "true";
      input.addEventListener("click", async (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper
            .querySelector(".js-color-swatches-link")
            .setAttribute("href", event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper
              .querySelector('.card__add-to-cart button[name="add"]')
              .setAttribute("aria-disabled", false);
            wrapper
              .querySelector('.card__add-to-cart button[name="add"] > span')
              .classList.remove("hidden");
            wrapper
              .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
              .classList.add("hidden");
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
              event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          try {
            const product = await fetchProductByHandle(handleProduct);
            if (!product) {
              return;
            }

            const variant = product.variants.filter(
              (item) =>
                item.featured_media != null &&
                item.options.includes(currentColor),
            )[0];

            if (variant) {
              const newPrimaryImage = createImageElement(
                variant["featured_media"],
                primaryImage.className,
                primaryImage.sizes,
                product.title,
              );

              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src)
                    .pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src)
                    .pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove("media--second");
                    secondaryImage.classList.add("media--first");
                    flag = true;
                  }
                }
                if (flag == false) {
                  primaryImage.animate(
                    { opacity: [1, 0] },
                    {
                      duration: 200,
                      easing: "ease-in",
                      fill: "forwards",
                    },
                  ).finished;
                  setTimeout(function () {
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate(
                      { opacity: [0, 1] },
                      { duration: 200, easing: "ease-in" },
                    );
                    if (secondaryImage) {
                      secondaryImage.remove();
                    }
                  }, 200);
                }
              }
            }
          } catch (error) {
            // Keep silent in storefront and preserve current media when request fails.
          }
        }
      });
    });
  });
};

const initColorSwatches = (root = document) => {
  bindColorSwatches(root);
};

window.initColorSwatches = initColorSwatches;
window.colorSwatches = initColorSwatches;

document.addEventListener("shopify:section:load", function (event) {
  initColorSwatches(event.target || document);
});

(function () {
  initColorSwatches();
})();